import PropTypes from 'prop-types';

import { Abstrap } from '../..';

const propTypes = {
    ...Abstrap.propTypes,
    action: PropTypes.bool,
    fluid: PropTypes.bool,
    isActive: PropTypes.bool,
};

const defaultProps = {
    ...Abstrap.defaultProps,
    componentClass: 'div',
    action: false,
    fluid: false,
    isActive: false,
};

class TabMenuItem extends Abstrap {

    getClassNameSchema() {
        const {
            className,
            action,
            fluid,
            isActive,
        } = this.props;
        return [
            'c-tab-menu__item',
            isActive ? 'is-active' : false,
            action ? 'c-tab-menu__item--action' : false,
            fluid ? 'c-tab-menu__item--fluid' : false,
            className,
        ];
    }

}

TabMenuItem.propTypes = propTypes;

TabMenuItem.defaultProps = defaultProps;

export default TabMenuItem;
